<template>
    <div class="profile-dashboard__meta d-flex">

        <div class="profile-dashboard__meta-item d-flex">
            <div class="profile-dashboard__meta-icon d-flex">
                <img src="/assets/images/icons/wDog.svg" alt="">
            </div>
            <div class="profile-dashboard__meta-about">
                <div class="profile-dashboard__meta-count">
                    {{(dashboard && dashboard.funds_available) || 0}} BYN
                </div>
                <div class="profile-dashboard__meta-description">средств доступно</div>
            </div>

        </div>

        <div class="profile-dashboard__meta-item d-flex">

            <div class="profile-dashboard__meta-icon d-flex">
                <img src="/assets/images/icons/wMoney.svg" alt="">
            </div>
            <div class="profile-dashboard__meta-about">
                <div class="profile-dashboard__meta-count">{{(user && user['raised_by_user']) || 0}} BYN</div>
                <div class="profile-dashboard__meta-description">всего средств собрано</div>
            </div>

        </div>

        <div class="profile-dashboard__meta-item d-flex">

            <div class="profile-dashboard__meta-icon d-flex">
                <img src="/assets/images/icons/wHeart.svg" alt="">
            </div>
            <div class="profile-dashboard__meta-about">
                <div class="profile-dashboard__meta-count">{{(dashboard && dashboard.follows_count) || 0}}</div>
                <div class="profile-dashboard__meta-description">отслеживаемых животных</div>
            </div>

        </div>

        <div class="profile-dashboard__meta-item d-flex">

            <div class="profile-dashboard__meta-icon d-flex">
                <img src="/assets/images/icons/wDoc.svg" alt="">
            </div>
            <div class="profile-dashboard__meta-about">
                <div class="profile-dashboard__meta-count">{{(dashboard && dashboard.facilities_count) || 0}}</div>
                <div class="profile-dashboard__meta-description">размещено объявлений</div>
            </div>

        </div>

    </div>

</template>

<script>
export default {
    name: "UserDashboardMeta",
    props: ['dashboard', 'user'],
}
</script>

<style scoped>

</style>
